export default "__VITE_ASSET__cee0703a__"